module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/share-cfddbecf7ce45b4e0eb64b9ec87bb314.svg";